<template>
  <div data-luko-tracking="Page-Refunds">
    <RefundsModule :data="data" />
  </div>
</template>

<script>
import RefundsModule from '~/modules/Refunds'
import { formatMetaDatas } from '~/utils/metaData'

export default {
  head() {
    return formatMetaDatas(this.metaDatas, this.$route.path)
  },

  components: {
    RefundsModule,
  },

  async asyncData({ $prismic, app, store, error }) {
    try {
      const { data, alternate_languages } = await $prismic.api.getSingle('refunds_page', {
        lang: app.i18n.localeProperties.prismicIso,
      })

      store.dispatch('setAlternateLanguages', alternate_languages)
      // Force to set theme for navbar and footer
      store.commit('page/UPDATE', { primary: { theme: '2021Q4-pink' } })

      return {
        data,
        metaDatas: data.body1 || [],
      }
    } catch (e) {
      console.error(e)
      error({ statusCode: 500, message: 'Error in asyncData' })
    }
  },
}
</script>
